import EntityType from '@enums/EntityType';
import {
  PropertyEntity,
  SkillEntity,
  TagEntity,
} from '@enums/MappedEntityTypes';

export default function getTreeItemType(type, subType) {
  switch (subType) {
    case EntityType.ACTIVITY_TYPE:
      return EntityType.ACTIVITY_TYPE;
    case EntityType.ROLE_TYPE:
      return EntityType.ROLE_TYPE;
    case EntityType.SKILL:
      return SkillEntity[type];
    case EntityType.TAG:
      return TagEntity[type];
    case EntityType.PROPERTY:
      return PropertyEntity[type];
    default:
      return type;
  }
}
